module.exports = global["Global"] = require("-!/app/gamesl/node_modules/babel-loader/lib/index.js??ref--2-0!./global.js");